import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch, fetchProfile, setToken } from '@/store';
import { APP_CONFIG } from '@/constants/app';

export const useAppInit = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Check if token exists in localStorage on app initialization
        const storedToken = localStorage.getItem(APP_CONFIG.TOKEN_KEY);
        
        if (storedToken) {
          // Set token in Redux state
          dispatch(setToken(storedToken));
          
          // Fetch user profile if token exists
          try {
            await dispatch(fetchProfile()).unwrap();
          } catch (error) {
            // If profile fetch fails, clear the invalid token
            localStorage.removeItem(APP_CONFIG.TOKEN_KEY);
            console.warn('Invalid token removed:', error);
          }
        }
      } catch (error) {
        console.error('App initialization error:', error);
      } finally {
        setIsInitialized(true);
      }
    };

    initializeApp();
  }, [dispatch]);

  return { isInitialized };
};